import {fetchGet} from "@/libs/reqCommon"
const state = {
	noticeChannel:[],
	rectificationformArr:[],
	noticeReviewCount: [],
	noticeReviewData:{},
	noticeReviewDetail: {},
	autoReviewTime:0,
	noticeKefuname:[],
  }
  const	getters = {
	rectificationformArr: state => {
		let arr = [{
			value:0,
			label:'通知整改'
		},{
			value:1,
			label:'通知下架'
		}]
		state.rectificationformArr = arr;
		return state.rectificationformArr;
	},
	noticeChannel: state => {
		let arr = [{
			value:0,
			label:'旺旺等聊天工具通知'
		},{
			value:1,
			label:'微信公众号通知'
		}]
		state.noticeChannel = arr;
		return state.noticeChannel;
	},
	noticeReviewCount: state => {
	  let arr=[
		{
			num: `${state.noticeReviewCount.cas1 || 0}`,
			name: `待复查`,
			label: `待复查 (${state.noticeReviewCount.cas1 || 0})`,
			value: state.noticeReviewCount.cas1,
			type:1
		},
		{
			name: `已复查-合格`,
			label: `已复查-合格 (${state.noticeReviewCount.cas2 || 0})`,
			value: state.noticeReviewCount.cas2,
			type:5
		},
		{
			name: `已复查-不合格`,
			label: `已复查-不合格 (${state.noticeReviewCount.cas5 || 0})`,
			value: state.noticeReviewCount.cas5,
			type:6
		},
		{
			name: `超时未复查`,
			label: `超时未复查 (${state.noticeReviewCount.cas3 || 0})`,
			value: state.noticeReviewCount.cas3,
			type:3
		},
		{
			name: `全部`,
			label: `全部 (${state.noticeReviewCount.cas4 || 0})`,
			value: state.noticeReviewCount.cas4,
			type:4,
		}
	  ]
	  return arr
	},
  }
  const	mutations = {
	getNoticeReviewCount(state,payLoad){
		state.noticeReviewCount = payLoad;
	},
	getNoticeReviewData(state,payLoad){
	  state.noticeReviewData = payLoad;
	},
	getNoticeReviewDetail(state,payLoad){
		if(payLoad.reviewurl){
			payLoad.reviewurl = payLoad.reviewurl.split(',')
		}
		if(payLoad.file){
			payLoad.file = payLoad.file.split(',');
			let fileArr = [];
			if(payLoad.file.length>0){
				for(let item of payLoad.file){
					let itemname = item.slice(item.indexOf('_')+1);
					let itemurl = item.split('https://hawksights.obs.cn-east-2.myhuaweicloud.com/')[1];
					let obj = {
						name:itemname,
						url:itemurl
					};
					fileArr.push(obj);
				}
				payLoad.file = fileArr;
			}
		}
		state.noticeReviewDetail = payLoad;
	},
	getNoticeReviewTime(state,payLoad){
		if (payLoad.time <= 60) {
			state.autoReviewTime = `${payLoad.time}秒`;
		} else {
			let min = parseInt(payLoad.time / 60);
			let sec = payLoad.time % 60;

			state.autoReviewTime = `${min}分钟${sec}秒`;
		}
	},
	getNoticeKefuname(state,payLoad){
		state.noticeKefuname = payLoad;
	}
  }
  const	actions = {
	//客服下拉
	reqNoticeKefuname({commit},params){
		return new Promise((r,j)=>{
			fetchGet('/hcm/userin/getuserinAll',params).then(res=>{
				commit('getNoticeKefuname',res.data)
			})
			r()
		}).catch(() => {
			j();
		})
	},
	//通知复查数量
	reqNoticeReviewCount( {commit},params){
		return new Promise((r,j)=>{
			fetchGet('/hcm/wechatnotice/getwechatnoticelistcount',params).then(res=>{
				commit('getNoticeReviewCount',res.data)
			})
		})
	},
	//  违规通知复查表格
	reqNoticeReviewData( { commit }, params ) {
		return new Promise((r,j)=>{
			fetchGet("/hcm/wechatnotice/getwechatnoticelist",params).then((res) => {
				commit('getNoticeReviewData', res.data);
				r();
			}).catch(() => {
				j();
			})
		})
	  },
	//   通知复查详情
	reqNoticeReviewDetail( {commit},params) {
		let url = ''
		let type = JSON.parse(window.localStorage.userData)
		if (type.logintype == 'KEFU') {
			url = '/hcm/wechatnotice/getnoticeitemdetails'
		} else {
			url = '/hcm/iprViolationRetrieveData/iprViolationRetrieveDatadetails'
		}
		return new Promise((r,j)=>{
			fetchGet(url,params).then((res) => {
				commit('getNoticeReviewDetail', res.data);
				r();
			}).catch(() => {
				j();
			})
		})
	},
	// 自动复查
	reqNoticeReviewAuto({commit}){
		return new Promise((r,j)=>{
			fetchGet("/hcm/wechatnotice/autoreview").then((res) => {
				commit('getNoticeReviewTime', res.data);
				r(res);
			}).catch(() => {
				j();
			})
		})
	}

  }

  export default {
	state,
	getters,
	mutations,
	actions
  }
